import React from "react";
import Moment from "react-moment";

function FullDateFormat(props) {
  return <Moment format="ddd, ll">{props.children}</Moment>;
}

export default FullDateFormat;
